import * as React from 'react';
import { ExpandLess, ExpandMore, Home, List, Lock, Logout, Person, Task, WorkOutline, Campaign, FolderShared, Assessment } from '@mui/icons-material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import { LOGOUT, PRIVATE, PRIVATE_ADMIN, PRIVATE_ADMIN_NEWS, PRIVATE_ADMIN_DOCUMENTS, PRIVATE_ADMIN_REPORTS } from 'Shared/Routing/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_LIST_USERS } from 'User/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_LIST_PERMISSIONGROUPS } from 'PermissionGroup/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_LIST_JOBPOSITIONS } from 'JobPosition/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_LIST_PERMISSIONS } from 'Permission/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS } from 'ScheduledCommand/Application/Constants/PathsConstant';
import { useTranslation } from 'react-i18next';
import { Collapse } from '@mui/material';

export function MainListItems() {
  const { t } = useTranslation();
  const [openUsersAndPermissions, setOpenUsersAndPermissions] = React.useState(false);

  const handleClickUsersAndPermissions = () => {
    setOpenUsersAndPermissions(!openUsersAndPermissions);
  };
  var listItems = [];
  listItems.push(
    <ListItemButton key={PRIVATE_ADMIN} component={Link} to={PRIVATE_ADMIN}>
      <ListItemIcon>
        <Home />
      </ListItemIcon>
      <ListItemText primary={t('ui.menus.admin.home')} />
    </ListItemButton>
  );
  listItems.push(
    <div key={'usersAndPermissions'}>
      <ListItemButton onClick={handleClickUsersAndPermissions} className="collapseControlButton" key={'openUsersAndPermissions'}>
        <ListItemIcon>
          <List />
        </ListItemIcon>
        <ListItemText primary="Usuarios y Permisos" />
        {openUsersAndPermissions ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openUsersAndPermissions} timeout="auto" unmountOnExit>
        <ListItemButton key={PRIVATE_ADMIN_LIST_USERS} component={Link} to={PRIVATE_ADMIN_LIST_USERS}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary={t('ui.menus.admin.users')} />
        </ListItemButton>
        <ListItemButton key={PRIVATE_ADMIN_LIST_PERMISSIONGROUPS} component={Link} to={PRIVATE_ADMIN_LIST_PERMISSIONGROUPS}>
          <ListItemIcon>
            <Lock />
          </ListItemIcon>
          <ListItemText primary={t('ui.menus.admin.permissionGroups')} />
        </ListItemButton>
        <ListItemButton key={PRIVATE_ADMIN_LIST_JOBPOSITIONS} component={Link} to={PRIVATE_ADMIN_LIST_JOBPOSITIONS}>
          <ListItemIcon>
            <WorkOutline />
          </ListItemIcon>
          <ListItemText primary={t('ui.menus.admin.jobPositions')} />
        </ListItemButton>
        <ListItemButton key={PRIVATE_ADMIN_LIST_PERMISSIONS} component={Link} to={PRIVATE_ADMIN_LIST_PERMISSIONS}>
            <ListItemIcon>
              <Lock />
            </ListItemIcon>
            <ListItemText primary={t('ui.menus.admin.permissions')} />
        </ListItemButton>
      </Collapse>
    </div>
  );
  listItems.push(
    <ListItemButton key={PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS} component={Link} to={PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS}>
        <ListItemIcon>
          <Task />
        </ListItemIcon>
        <ListItemText primary={t('ui.menus.admin.scheduledCommands')} />
    </ListItemButton>
  );
  listItems.push(
    <ListItemButton key={PRIVATE_ADMIN_NEWS} component={Link} to={PRIVATE_ADMIN_NEWS}>
        <ListItemIcon>
          <Campaign />
        </ListItemIcon>
        <ListItemText primary="Noticias Carrusel" />
    </ListItemButton>
  );
  listItems.push(
    <ListItemButton key={PRIVATE_ADMIN_DOCUMENTS} component={Link} to={PRIVATE_ADMIN_DOCUMENTS}>
        <ListItemIcon>
          <FolderShared />
        </ListItemIcon>
        <ListItemText primary="Gestión Documentos" />
    </ListItemButton>
  );
  listItems.push(
    <ListItemButton key={PRIVATE_ADMIN_REPORTS} component={Link} to={PRIVATE_ADMIN_REPORTS}>
        <ListItemIcon>
          <Assessment />
        </ListItemIcon>
        <ListItemText primary="Informes Generados" />
    </ListItemButton>
  );

  return (
    <React.Fragment>
      {listItems}
    </React.Fragment>
  );

};

export function SecondaryListItems(){
  const { t } = useTranslation();
  var listItems = [];
  listItems.push(
    <ListItemButton key={PRIVATE} component={Link} to={PRIVATE}>
        <ListItemIcon>
          <Person />
        </ListItemIcon>
        <ListItemText primary={t('ui.menus.admin.user')} />
    </ListItemButton>
  );
  listItems.push(
    <ListItemButton key={LOGOUT} component={Link} to={LOGOUT}>
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText primary={t('ui.menus.admin.logout')} />
    </ListItemButton>
  );
  return (
    <React.Fragment>
      {listItems}
    </React.Fragment>
  );
};
